<template>
    <v-app>
        <v-main>
            <!-- Toolbar -->
            <v-toolbar elevation="1">
                <v-layout row class="display-1 ml-2">
                    <div id="font">
                        Simples
                    </div>
                    <div id="font" class="primary--text">
                        Medic
                    </div>
                </v-layout>

                <v-spacer />

                <div class="text-center">
                    <atendimentoAntecipado @examesSelecionados="adicionarServicos" />
                </div>

                <div class="text-center">
                    <v-btn @click="listaDeOsGeradas = true" icon color="#008080">
                        <v-icon>list</v-icon>
                    </v-btn>

                    <v-btn title="Logout" text icon color="primary" @click="logout()">
                        <v-icon>logout</v-icon>
                    </v-btn>
                </div>
            </v-toolbar>

            <!-- Dialogs -->
            <v-dialog persistent v-model="aguardandoConexao" width="300">
                <v-card color="primary" dark>
                    <v-card-text>
                        Aguardando conexão...
                        <v-progress-linear indeterminate color="white" class="mb-0" />
                    </v-card-text>
                </v-card>
            </v-dialog>

            <v-dialog v-model="dialogErroServico" max-width="470">
                <v-card>
                    <v-layout justify-center class="white--text headline red pa-2 lighten-2">
                        Aviso
                    </v-layout>
                    <v-card-text>
                        <strong class="text--lighten-1">** O serviço de {{ mensagemServicoErrado }} deve ser escolhido
                            sem outro(s) serviço(s).</strong>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer />
                        <v-btn color="green darken-1" text @click="dialogErroServico = false">
                            Ok
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog flat v-model="listaDeOsGeradas" width="900">
                <v-card shaped flat height="625" class="mt-6" outlined>
                    <v-card-title class="grey lighten-4">
                        <div class="blue--text text--darken-1">Pacientes Pré Atendimento</div>
                        <v-spacer />
                        <v-btn icon color="blue darken-1" dark @click="listaDeOsGeradas = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-card-title>

                    <v-card-text>
                        <v-text-field label="Pesquise pelo CPF" v-mask="mask" v-model="search" solo clearable
                            prepend-icon="mdi-magnify" />
                    </v-card-text>

                    <v-card flat class="overflow-y-auto mt-0 pt-0" height="400">
                        <v-list v-if="!loading">
                            <v-list-item-group>
                                <v-list-item v-for="(paciente, index) in filteredItems" :key="index"
                                    @click="cliente = paciente">
                                    <v-list-item-avatar>
                                        <v-icon>mdi-account</v-icon>
                                    </v-list-item-avatar>
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            <strong>{{ paciente.nome }}</strong>
                                        </v-list-item-title>
                                        <v-list-item-subtitle v-if="!paciente.cpf">
                                            CPF: <strong> ---.-- </strong>
                                        </v-list-item-subtitle>
                                        <v-list-item-subtitle v-else>
                                            CPF: <strong class="indigo--text">{{ paciente.cpf.slice(0, 3) + '.' +
                                                paciente.cpf.slice(3) + '*.***-**' }}</strong>
                                        </v-list-item-subtitle>
                                        <v-list-item-subtitle>
                                            Sexo: <strong>{{ paciente.sexo || '-----' }}</strong>
                                        </v-list-item-subtitle>
                                        <v-list-item-subtitle>
                                            Data de Nascimento: <strong class="green--text">{{ paciente.dataNascimento ?
                                                formatarData(paciente.dataNascimento) : '-----' }}</strong>
                                        </v-list-item-subtitle>
                                    </v-list-item-content>
                                    <v-list-item-icon>
                                        <v-icon color="green">mdi-vector-link</v-icon>
                                    </v-list-item-icon>
                                </v-list-item>
                            </v-list-item-group>

                            <v-alert v-if="filteredItems.length === 0 && search.length > 1" type="warning" class="mx-2"
                                dismissible>
                                Nenhum paciente encontrado.
                            </v-alert>
                        </v-list>

                        <v-skeleton-loader v-else height="100%" type="list-item-three-line"></v-skeleton-loader>
                    </v-card>
                </v-card>
            </v-dialog>

            <!-- Unidade de Atendimento -->
            <v-divider />
            <div class="text-center">
                <h1>
                    <p class="text-sm-center font-weight-bold">
                        Escolha a unidade de Atendimento
                    </p>
                </h1>
            </div>

            <v-layout class="mb-1">
                <v-flex>
                    <v-layout row wrap align-start justify-center fill-height>
                        <v-card v-for="(item, index) in listaServicosPorIdUnidade" :key="index"
                            class="rounded-lg ma-3 pa-6" hover height="140" width="150" :color="item[0].cor"
                            :class="item[0].opacidade ? 'opacidade' : 'elevation-12'" outlined tile dark
                            @click="setarListaDeServicos(item[0])">
                            <v-layout row align-center class="title">
                                {{ item[0].nomeUnidadeEtiqueta || item[0].nomeUnidade }}
                            </v-layout>
                        </v-card>
                    </v-layout>
                </v-flex>
            </v-layout>

            <v-divider />
            <v-select class="mx-16 mt-2" v-model="idLocal" rounded :items="listaLocais" label="Selecione o local para priorizar a recepcionista correspondente" dense
                item-value="idLocal" item-text="nomeLocal" solo></v-select>
            <!-- Escolha de Serviços -->
            <div>
                <h1>
                    <p class="mb-1 text-sm-center font-weight-bold">
                        Escolha serviço(s) da Unidade
                    </p>
                </h1>
            </div>
            <v-layout column row justify-center class="pa-4 mx-2">
                <v-layout row wrap align-start justify-center fill-height>
                    <v-flex v-for="(servico, index) in servicosExibidos" :key="index" class="px-1 mb-3" xs9 sm6 md3 lg2
                        align-center>
                        <v-card id="v-card" max-width="240" :outlined="!servico.color"
                            :elevation="servico.color ? 6 : 0" class="text-center rounded-lg"
                            @click="addServico(servico, index)">
                            <v-img :src="servico.avatar" height="90px" />
                            <v-card-text>
                                <v-card :color="servico.color || 'grey darken-1'">
                                    <span class="white--text"><strong>{{ servico.nomeEspecialidade }} <br />
                                            {{ servico.nomeLocal }}</strong></span>
                                </v-card>
                                <br>
                                <div v-if="servico.quantVagas >= 5" class="text-truncate">
                                    Qtd vagas: <strong>{{ servico.quantVagas }}</strong>
                                </div>
                                <div v-if="servico.quantVagas < 5 && servico.quantVagas > 0"
                                    class="text-truncate red--text">
                                    Qtd vagas: {{ servico.quantVagas }}
                                </div>
                                <div v-if="servico.quantVagas <= 0" class="red--text text-truncate">
                                    Vagas Esgotadas
                                </div>
                            </v-card-text>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-layout>

            <!-- Botões de Ação -->
            <v-fade-transition>

                <div v-if="servicos.length">
                    <v-layout column>

                        <v-layout row wrap>
                            <v-btn elevation="5" fixed right bottom v-show="!desabilitaBotaoGerarFicha" rounded
                                class="white--text mb-3" large dark color="#00bcd4" @click="gerarFicha">
                                <v-icon left>print</v-icon>
                                <strong> Gerar ficha </strong>
                            </v-btn>

                            <v-btn fixed right bottom class="ml-0 mr-2 mt-0 mb-16" rounded dark large
                                :color="prioridade ? '#60D606' : '#F77707'" @click="prioridade = !prioridade">
                                <v-icon left v-text="prioridade ? 'check_box' : 'check_box_outline_blank'"></v-icon>
                                <strong> Prioridade </strong>
                            </v-btn>
                        </v-layout>
                    </v-layout>
                </div>
            </v-fade-transition>
        </v-main>
        <v-dialog
        transition="dialog-bottom-transition"
        max-width="600"
        v-model="dialog"
      >
        <template v-slot:default="dialog">
          <v-card>
            <v-toolbar
              color="error"
              dark
            >Erro</v-toolbar>
            <v-card-text>
              <div class="text-h4 pa-12">O local que foi selecionado é diferente do local do exame.</div>
            </v-card-text>
            <v-card-actions class="justify-end">
              <v-btn
                text
                @click="dialog.value = false"
              >Fechar</v-btn>
            </v-card-actions>
          </v-card>
        </template>
      </v-dialog>
    </v-app>
</template>

<script>
// eslint-disable-next-line
/* eslint-disable */
//import Cookies from 'js-cookie'
import atendenteService from "../services/atendente.service";
import {
    getToken,
    setToken
} from "../store/auth";
import socketService from "../services/socket.service";
import atendimentoAntecipado from "../components/atendente/atendimentoAntecipado.vue";
import {
    mask
} from 'vue-the-mask'



export default {

    name: "homeAtendente",
    directives: {
        mask
    },
    components: {
        atendimentoAntecipado
    },
    data() {
        return {
            search: "",
            listaDeOsGeradas: false,
            senhaWifi: "",
            idLocal: null,
            listaLocais: [],
            aguardandoConexao: false,
            escolheuAtendimentoMedico: false,
            indexEscolhido: "",
            arrayTeste: [],
            exameSadt: false,
            dialog: false,
            dialogErroServico: false,
            mensagemServicoErrado: "",
            socket: "",
            entrouEmAguardandoConexao: false,
            user: {},
            loading: false,
            idUnidadeEscolhida: "",
            apareceDiv: true,
            desabilitaBotaoGerarFicha: false,
            idMedicoPreferencia: "",
            codigoFicha: "",
            prioridadeServico: false,
            nomeUnidade: "",
            etiqueta: "",
            ultimoCodigoChamado: "",
            ultimaPrioridadeChamada: "",
            servicosRetornadosOrdenados: [],
            listaServicosPorIdUnidade: [],
            primeiroServicoNaOrdem: "",
            desabilitaBotaoGerarFicha: false,
            segundoServicoNaOrdem: "",
            terceiroServicoNaOrdem: "",
            listaServicosPorIdUnidadeServicos: [],
            localPrimeiroAtendimento: "",
            perguntaPreferencia: false,
            prioridade: false,
            emergencia: false,
            mensagemNotificacaoSocket: "default",
            dadosFicha: {},
            servicos: [],
            servicosRecebidos: [],
            servicosExibidos: [],
            pacientes: [],
            search: '',
            mask: '###.###.###-##',
            items: [
                {
                    nome: "Ana Silva",
                    cpf: "123.456.789-00",
                    sexo: "Feminino",
                    data_nascimento: "1990-01-15"
                },
                {
                    nome: "Carlos Souza",
                    cpf: "987.654.321-00",
                    sexo: "Masculino",
                    data_nascimento: "1985-05-20"
                },
                {
                    nome: "Mariana Oliveira",
                    cpf: "111.222.333-44",
                    sexo: "Feminino",
                    data_nascimento: "1992-09-10"
                },
                {
                    nome: "João Pedro",
                    cpf: "555.666.777-88",
                    sexo: "Masculino",
                    data_nascimento: "1988-03-25"
                },
                {
                    nome: "Lucas Ferreira",
                    cpf: "444.555.666-77",
                    sexo: "Masculino",
                    data_nascimento: "1995-07-30"
                },
                {
                    nome: "Fernanda Lima",
                    cpf: "333.444.555-66",
                    sexo: "Feminino",
                    data_nascimento: "1991-12-05"
                }
            ]
        };
    },
    props: {
        source: String
    },

    methods: {
        // filtrarServicosQuantidadeMaiorQueZero(){
        //   return this.servicosExibidos.filter(servico => {
        //       return servico.quantVagas > 0
        //    })
        // },
        retornarLocais() {
            atendenteService.atendente
                .retornarLocais(this.user.idUnidade)
                .then(rsp => {
                    console.log("rsp retornarLocais:", rsp.data);
                    this.listaLocais = rsp.data;
                })
                .catch(err => {
                    // handle your error here
                    console.log(err);
                });
        },

        adicionarServicosNomePaciente(servicos, nomePaciente) {
            console.log('-----------l>>>', servicos)
            this.servicos = servicos
            this.gerarFicha()
        },
        adicionarServicos(servicos) {
            console.log('-----------l>>>', servicos)
            this.servicos = servicos
            this.gerarFicha()
        },
        quantVagas(quantVagas) {
            return quantVagas === 0;
        },

        desabilitarCard(servico) {
            return false;
        },

        removerServicoQtdZero() {
            for (let index = 0; index < this.servicosRecebidos.length; index++) {
                const element = this.servicosRecebidos[index];
                if (element.quantVagas == 0) {
                    this.servicosRecebidos.splice(index, 1);
                }
            }
        },

        setarListaDeServicos(item) {
            console.log("item..", item);
            this.prioridade = false;

            this.listaServicosPorIdUnidade.forEach(element => {
                element[0].opacidade = 1; // preto
            });

            item.opacidade = 0; // vermelho

            this.servicosRecebidos.forEach(element => {
                element.color = "";
            });

            this.nomeUnidade = item.nomeUnidadeEtiqueta ?
                item.nomeUnidadeEtiqueta :
                item.nomeUnidade;
            this.servicos = []; // coloquei agora
            this.servicosExibidos = this.filtrarServicoPorIdUnidade(item.idUnidade);
        },

        //ok
        converterMes(mes) {
            var month = [];
            month[0] = "janeiro";
            month[1] = "fevereiro";
            month[2] = "março";
            month[3] = "abril";
            month[4] = "maio";
            month[5] = "junho";
            month[6] = "julho";
            month[7] = "agosto";
            month[8] = "setembro";
            month[9] = "outubro";
            month[10] = "novembro";
            month[11] = "dezembro";

            return month[mes];
        },

        gerarCodigoNaMaquina2() {
            var d = new Date();
            var mes = this.converterMes(parseInt(d.getMonth()));
            let tela_impressao = window.open();
            //.document.writeln("&nbsp;&nbsp;Centro Médico dos Remédios"+'</br>');
            tela_impressao.document.writeln(
                "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" +
                this.nomeUnidade +
                "</br>"
            );
            tela_impressao.document.writeln(
                "-----------------------------------------------------" + "</br>"
            );
            tela_impressao.document.writeln(
                "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Senha de Atendimento </br>"
            );
            tela_impressao.document.writeln(
                "-----------------------------------------------------" + "</br>"
            );

            //tela_impressao.document.writeln("&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;");
            tela_impressao.document.writeln(
                "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp&nbsp;&nbsp;&nbsp;  <font  size = '7'>" +
                this.codigoFicha +
                "</font>  </br>"
            );
            /* if (this.prioridadeServico === 0) {
                
                tela_impressao.document.writeln(
                    "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp&nbsp;&nbsp;&nbsp;  <font  size = '7'>" +
                    "C" +
                    this.codigoFicha +
                    "</font>  </br>"
                );
            } else if (this.prioridadeServico === 1) {
                tela_impressao.document.writeln(
                    "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp&nbsp;&nbsp;&nbsp;  <font  size = '7'>" +
                    "P" +
                    this.codigoFicha +
                    "</font>  </br>"
                );
            } else if (this.prioridadeServico === 2) {
                tela_impressao.document.writeln(
                    "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp&nbsp;&nbsp;&nbsp;  <font  size = '7'>" +
                    "B" +
                    this.codigoFicha +
                    "</font>  </br>"
                );
            } else if (this.prioridadeServico === 3) {
                tela_impressao.document.writeln(
                    "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp&nbsp;&nbsp;&nbsp;  <font  size = '7'>" +
                    "A" +
                    this.codigoFicha +
                    "</font>  </br>"
                );
            } */
            let nomeLocal = null; // Inicializa a variável para armazenar o valor
                    if (this.idLocal != null) {
                for (let i = 0; i < this.listaLocais.length; i++) {
                    if (this.listaLocais[i].idLocal === this.idLocal) { // Verifica a condição
                        nomeLocal = this.listaLocais[i].nomeLocal; // Armazena o nome do local
                        break; // Sai do loop já que encontrou o valor
                    }
                }
            }
            var localAtendimento = this.idLocal == null ? this.localPrimeiroAtendimento : nomeLocal
            tela_impressao.document.writeln(
                " &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <div> - Dirija-se a(o):  &nbsp; <b>" +
                localAtendimento +
                "</b> </br>"
            );
            var senha = "";
            switch (this.ultimaPrioridadeChamada) {
                case 0:
                    senha = "C" + this.ultimoCodigoChamado;
                    break;
                case 1:
                    senha = "P" + this.ultimoCodigoChamado;
                    break;
                case 2:
                    senha = "B" + this.ultimoCodigoChamado;
                    break;
                case 3:
                    senha = "A" + this.ultimoCodigoChamado;
                    break;
            }

            tela_impressao.document.writeln(
                " &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; - Última senha chamada:  &nbsp; <b>" +
                senha +
                "</b> </div> </br>"
            );

            tela_impressao.document.writeln(
                "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b>" +
                this.servicosRetornadosOrdenados[0].nomeEspecialidade +
                " </br>"
            );
            if (this.servicosRetornadosOrdenados.length > 1) {
                tela_impressao.document.writeln(
                    "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" +
                    this.servicosRetornadosOrdenados[1].nomeEspecialidade +
                    "</br>"
                );
            }
            if (this.servicosRetornadosOrdenados.length > 2) {
                tela_impressao.document.writeln(
                    "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" +
                    this.servicosRetornadosOrdenados[2].nomeEspecialidade +
                    "</br>"
                );
            }
            if (this.servicosRetornadosOrdenados.length > 3) {
                tela_impressao.document.writeln(
                    "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" +
                    this.servicosRetornadosOrdenados[3].nomeEspecialidade +
                    "</br>"
                );
            }
            if (this.servicosRetornadosOrdenados.length > 4) {
                tela_impressao.document.writeln(
                    "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" +
                    this.servicosRetornadosOrdenados[4].nomeEspecialidade +
                    "</br>"
                );
            }

            tela_impressao.document.write(
                "</b> <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Obrigado pela preferência <br/></p>"
            );
            tela_impressao.document.write(
                "<h5>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp" +
                d.getDate() +
                " de " +
                mes +
                " de " +
                d.getFullYear() +
                "  " +
                d.getHours() +
                ":" +
                d.getMinutes() +
                ":" +
                d.getSeconds() +
                "</h5></br>"
            );

            var textoWifi = ""
            if (
                this.user.idUnidade == 1 ||
                this.user.idUnidade == 20 ||
                this.user.idUnidade == 295 ||
                this.user.idUnidade == 133 ||
                this.user.idUnidade == 55
            ) {
                textoWifi = "<div>Conecte na rede CM WiFi. </div>" +
                    "<div>Usuário: <b>" + this.senhaWifi + "</b></div>" +
                    "<div>Senha: <b>" + this.senhaWifi + "</b></div>"
            }
            tela_impressao.document.write(
                textoWifi
            );
            tela_impressao.window.print();
            tela_impressao.window.close();
            this.codigoFicha = ''
        },
        chamarModalConexao() {
            console.log("em chamarModalConexao..");

            if (this.mensagemNotificacaoSocket == "aguardando conexao") {
                console.log("aguardando conex..");
                this.aguardandoConexao = true;
                this.entrouEmAguardandoConexao = true;
            } else if (this.mensagemNotificacaoSocket == "conectado") {
                console.log("conectado..");
                this.aguardandoConexao = false;
                if (this.entrouEmAguardandoConexao) {
                    this.retornarServicos();
                    this.entrouEmAguardandoConexao = false;
                }
            } else if (this.mensagemNotificacaoSocket == "desconectado") {
                console.log("desconectado..");
                this.aguardandoConexao = true;
            }
        },

        /**
         * Função para gerar uma senha para o wi-fi
         */
        buscarPrimeiroUsuarioValido() {
            var user = null
            atendenteService.atendente.buscarPrimeiroUsuarioValido().then((response) => {
                if (response.status == 200) {
                    user = response.data[0]
                    console.log('---- user', user.id)
                    this.gerarSenhaWifi(user.id)
                }
            }).catch((error) => {
                console.log(error);
            })
        },
        /**
         * Função para gerar uma senha para o wi-fi
         * @param {*} user
         */
        gerarSenhaWifi(user) {
            atendenteService.atendente.gerarSenhaWifi(user).then((response) => {
                if (response.status == 200) {
                    // console.log('---- senha', response.data[0])
                    this.senhaWifi = response.data[0].username
                    //this.imprimirSenhaWifi(senha)
                }
            }).catch((error) => {
                console.log(error);
            })
        },

        addServico(servico, index) {
            let isServico = false;
            console.log("add", servico);
            console.log(index);
            var servicoEncontrado = this.servicosExibidos.find(
                item => item.idServico == servico.idServico
            );

            if (servico.quantVagas == 0) {
                return;
            }

            if (
                this.servicos.length == 1 &&
                servicoEncontrado.color === "primary" &&
                servicoEncontrado.atendimentoMedico == 0
            ) {
                console.log("clicou novamente");
                //let serv = this.filteredList[index];
                servicoEncontrado.color = "";
                //serv.color = "";
                this.escolheuAtendimentoMedico = false;
                for (var i = 0; i < this.servicos.length; i++) {
                    // mudar idServico de acordo com o array...
                    if (this.servicos[i].idServico === servico.idServico) {
                        this.servicos.splice(i, 1);
                    }
                }
                return;
            }

            if (this.servicos.length == 0 && servico.atendimentoMedico == 0) {
                console.log("chamar dialog");
                this.escolheuAtendimentoMedico = true;
                this.indexEscolhido = index;
            } else if (this.escolheuAtendimentoMedico == true) {
                console.log("chamar dialog");
                this.mensagemServicoErrado = this.servicos[0].nomeEspecialidade;
                this.dialogErroServico = true;
                return;
            } else if (
                this.escolheuAtendimentoMedico == false &&
                this.servicos.length > 0 &&
                servico.atendimentoMedico == 0
            ) {
                console.log("chamar dialog");
                this.dialogErroServico = true;
                this.mensagemServicoErrado = servico.nomeEspecialidade;
                return;
            }

            var servicoEncontrado = this.servicosExibidos.find(
                item => item.idServico == servico.idServico
            );

            console.log("encontrado", servicoEncontrado);
            if (servicoEncontrado.color == "") {
                console.log("era branco");
                this.servicos.push(servicoEncontrado);
                servicoEncontrado.color = "primary";
                console.log("servicos apos add", this.servicos);
            } else {
                console.log("era vermelha");
                servicoEncontrado.color = "";
                for (var i = 0; i < this.servicos.length; i++) {
                    //mudar idServico de acordo com o array...
                    if (this.servicos[i].idServico === servicoEncontrado.idServico) {
                        this.servicos.splice(i, 1);
                    }
                }
                console.log("servicos apos remove", this.servicos);
            }

        },

        retornarProximoIdAtendimento() {
            //ok
            atendenteService.atendente
                .retornarProximoIdAtendimento()
                .then(rsp => {
                    console.log("resp: retornarProximoIdAtendimento");
                    console.log(rsp.data);
                })
                .catch(err => {
                    // handle your error here
                    console.log(err);
                });
        },

        removeServico(index) {
            //console.log(index);
            this.servicos[index].color = "";
            this.$delete(this.servicos, index);
        },

        gerarFicha() {
            this.escolheuAtendimentoMedico = false;
            this.desabilitaBotaoGerarFicha = true;
            // Re-enable after 5 seconds
            this.timeout = setTimeout(() => {
                // this.desabilitaBotaoGerarFicha = false;
            }, 2000);
            this.cadastrarConsultas();
        },

        cadastrarConsultas() {
            // var possuiLocal = this.servicos.some(servico => servico.idLocal == this.idLocal)
            
            // if (this.idLocal == null || possuiLocal) {
            this.buscarPrimeiroUsuarioValido();
            for (let index = 0; index < this.servicos.length; index++) {
                const element = this.servicos[index];
                let upperCase = element.nomeEspecialidade.toUpperCase();
                if ("LABORATÓRIO" == upperCase || "LABORATORIO" == upperCase) {
                    let servicoAux = element;
                    this.servicos.splice(index, 1);
                    this.servicos.unshift(servicoAux);
                }
            }
            this.exameSadt = this.servicos.some(servico => servico.sadt == 1)
            var todosSadt = this.servicos.every(servico => servico.sadt == 1)
            var nenhumSadt = this.servicos.every(servico => servico.sadt != 1)
           
            if (todosSadt) {
                this.codigoFicha += "T" // T de "Todos"
            } else if (nenhumSadt) {
                this.codigoFicha += "N"; // N de "Nenhum"
            }
            this.codigoFicha += this.exameSadt ? 'L' : '';

            if (this.prioridade) {
                this.codigoFicha = "P" + this.codigoFicha;
            } else {
                this.codigoFicha = "C" + this.codigoFicha;
            }

            atendenteService.atendente
                .cadastrarConsultas(this.servicos, this.prioridade, '', this.codigoFicha, null, this.idLocal)
                .then(rsp => {

                    console.log("rsp cadastrar consultas", rsp);
                    this.codigoFicha += rsp.data[0].codigo;
                    this.ultimoCodigoChamado = rsp.data[0].ultimoCodigoChamado;
                    this.ultimaPrioridadeChamada = rsp.data[0].ultimaPrioridadeChamada;
                    this.prioridadeServico = rsp.data[0].prioridade;
                    this.localPrimeiroAtendimento = rsp.data[0].nomeLocal;
                    this.servicosRetornadosOrdenados = rsp.data;
                    this.gerarCodigoNaMaquina2()
                    this.servicosRecebidos.forEach(elementRecebido => {
                        elementRecebido.color = "";
                    });
                    this.prioridade = false;
                    this.servicos = [];
                    this.montarInterface();
                    this.desabilitaBotaoGerarFicha = false;
                }).finally(() => {
                    this.codigoFicha = ''
                    this.idLocal = null
                })
                .catch(err => {
                    // console.log("catch..");
                    this.desabilitaBotaoGerarFicha = false;
                    console.log(err);
                });
            /*} else {
                this.desabilitaBotaoGerarFicha = false
                this.dialog = true
            }*/
        },

        filtrarServicoPorIdUnidade(idUnidade) {
            return this.servicosRecebidos.filter(servico => {
                return servico.idUnidade == idUnidade;
            });
        },

        refreshToken() {
            atendenteService.atendente
                .refreshToken(getToken())
                .then(rsp => {
                    if (rsp.status == 200) {
                        setToken(rsp.data.token)
                        this.socket.close()
                        this.socket = io.connect(socketService.SOCKET_URL, {
                            query: {
                                token: getToken()
                            }
                        })
                        console.log(rsp.data.token);
                        this.chamarSocket()
                    } else {
                        this.logout()
                    }
                })
                .catch(err => {
                    // handle your error here
                    console.log(err)
                    this.logout()
                })
        },

        groupBy(collection, property) {
            var i = 0,
                val,
                index,
                values = [],
                result = [];
            for (; i < collection.length; i++) {
                val = collection[i][property];
                index = values.indexOf(val);
                if (index > -1) result[index].push(collection[i]);
                else {
                    values.push(val);
                    result.push([collection[i]]);
                }
            }
            return result;
        },

        retornarServicos() {
            //aqui
            console.log("em retornar servicos..");
            console.log(this.servicosRecebidos);
            this.servicosRecebidos = []
            atendenteService.atendente
                .retornarServico()
                .then(rsp => {
                    if (rsp.data.length) { }
                    console.log("rsp retornarServicos", rsp);
                    let data = rsp.data;
                    console.log(data);
                    data.forEach(element => {
                        element.color = "";
                        element.colorUnidade = "#212121";
                    });
                    //this.arrayTeste = this.groupBy(data, "idUnidade");
                    this.servicosRecebidos = data;
                    this.montarInterface();
                    //this.servicosRecebidos = rsp.data
                })
                .catch(err => {
                    // handle your error here
                    console.log(err);
                });
        },

        logout() {
            console.log("em logout..");
            //this.$router.push("/login");
            this.$store
                .dispatch("FedLogOut")
                .then(rsp => {
                    this.socket ? this.socket.close() : "";
                    this.$router.push("/login");
                    if (r) { }
                })
                .catch(error => {
                    //this.progress = false;
                    //this.alert = true;
                    //this.msg = error;
                });
        },

        montarInterface() {
            this.servicosRecebidos.forEach(element => {
                element.color = "";
                element.opacidade = 1; // adicionei
                element.colorUnidade = "#212121"; // preto
            });

            this.listaServicosPorIdUnidade = this.groupBy(
                this.servicosRecebidos,
                "idUnidade"
            );
            this.servicosExibidos = this.filtrarServicoPorIdUnidade(
                this.user.idUnidade
            );

            if (this.servicosExibidos.length) {
                // servicos da unidade da atendente
                this.nomeUnidade = this.servicosExibidos[0].nomeUnidadeEtiqueta ?
                    this.servicosExibidos[0].nomeUnidadeEtiqueta :
                    this.servicosExibidos[0].nomeUnidade;
                this.servicosExibidos.forEach(element => {
                    element.opacidade = 0;
                    element.colorUnidade = "#C62828"; // vermelho
                });
            } else {
                var servicosExibidosAux = this.groupBy(
                    this.servicosRecebidos,
                    "idUnidade"
                );
                this.servicosExibidos = servicosExibidosAux[0];
                this.nomeUnidade = this.servicosExibidos[0].nomeUnidadeEtiqueta ?
                    this.servicosExibidos.nomeUnidadeEtiqueta :
                    this.servicosExibidos.nomeUnidade;
                this.servicosExibidos.forEach(element => {
                    element.opacidade = 0;
                    element.colorUnidade = "#C62828"; // vermelho
                });
            }
        },
        atualizarAtendente() {
            var date = new Date() // Create a Date object to find out what time it is
            if (date.getHours() === 0 && date.getMinutes() == 30) {
                this.retornarServicos();
            }
        },
        chamarSocket() {
            console.log("em chamar socket...");

            this.socket.on(
                "novaFichaGerada",
                function (mensagem) {
                    console.log("em novaFichaGerada");
                    console.log(mensagem);
                    this.servicosRecebidos.forEach(elementRecebido => {
                        mensagem.servicos.forEach(element => {
                            if (elementRecebido.idServico == element.idServico) {
                                elementRecebido.quantVagas = elementRecebido.quantVagas - 1;
                            }
                        });
                    });

                    //this.mensagemNotificacao = mensagem;
                }.bind(this)
            );

            this.socket.on(
                "atualizarVagas",
                function (mensagem) {
                    console.log("skt atualizar vagas");
                    console.log(mensagem);
                    this.servicosRecebidos.forEach(elementRecebido => {
                        mensagem.forEach(element => {
                            if (elementRecebido.idServico == element.idServico) {
                                elementRecebido.quantVagas = element.quantVagas;
                            }
                        });
                    });
                }.bind(this)
            );

            this.socket.on(
                "connect",
                function (mensagem) {
                    this.mensagemNotificacaoSocket = "conectado";
                    this.chamarModalConexao();
                }.bind(this)
            );

            this.socket.on("connect_error", () => {
                this.mensagemNotificacaoSocket = "aguardando conexao";
                this.chamarModalConexao();
            });

            this.socket.on(
                "disconnect",
                function () {
                    this.mensagemNotificacaoSocket = "desconectado";
                    this.chamarModalConexao();
                }.bind(this)
            );
        }
    },

    computed: {
        filteredList() {
            return this.servicosExibidos.filter(post => {
                return post.nomeEspecialidade
                    .toLowerCase()
                    .includes(this.search.toLowerCase());
            });
        },

        filtroMaiorQZero() {
            // coloquei esse
            return this.servicosExibidos.filter(servico => {
                return servico.quantVagas > 0;
            });
        },
        filteredItems() {
            if (!this.search) {
                return this.items;
            }
            return this.items.filter(item =>
                item.cpf.includes(this.search)
            );
        }


    },

    mounted() {
        console.log("mounted");
        this.user = this.$store.getters.usuario;
        if (this.user.tipo != 3) {
            this.$router.push("/login");
            return;
        }

        this.socket = io.connect(socketService.SOCKET_URL, {
            query: {
                token: getToken()
            }
        });
        console.log(this.user);
        this.retornarServicos();
        this.chamarSocket();
        this.retornarLocais()
        setInterval(() => this.refreshToken(), 28800000)
        // setInterval(() => this.refreshToken(), 10000)
        setInterval(() => this.atualizarAtendente(), 20 * 1000)

    },

    created() {
        window.addEventListener("beforeunload", event => {
            //confirm('Deseja ativar esse Medico?')
            //window.open("http://www.google.com/", "minhaJanela", "height=200,width=200");
            // event.timeStamp = 'deseja realmente sair ??';
        });
    }
};
</script>

<style lang="scss" scoped>
.resultContainer {
    height: 350px;
}

.item {
    min-height: 50px;
    min-width: 80px;
    margin: 10px;
}

html,
body {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin-top: 16px;
    margin-bottom: 16px;
}

div#app {
    .wrapper {
        display: flex;
        max-width: 644px;
        flex-wrap: wrap;
        padding-top: 12px;
    }

    #v-card {
        transition: 0.15s all ease-in-out;
    }

    .hotpink {
        background: hotpink;
    }

    .green {
        background: green;
    }

    .box {
        width: 100px;
        height: 100px;
        border: 1px solid rgba(0, 0, 0, 0.12);
    }

    .opacidade {
        opacity: 0.3;
    }

    .rounded-card {
        border-radius: 5px;
    }
}
</style>
